import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

const UserAgreement = ({ onClose }) => {
  const [isCheckboxChecked, setIsCheckboxChecked] = useState(false);
  const { t } = useTranslation();

  const handleCheckboxChange = (event) => {
    setIsCheckboxChecked(event.target.checked);
  };

  const handleAcceptButtonClick = () => {
    onClose();
  };

  const handleMainPageLinkClick = () => {};

  return (
    <div id="user_agreement">
      <div className="user-agreement">
        <div className="user-agreement__flex-wrapper">

          {/* Қазақша нұсқасы */}
          <div className="user-agreement__col1">
            <h3>
              «Қазақстан Республикасының Ұлттық куәландырушы орталығы» ақпараттық жүйесінде пайдаланушының келісімі
            </h3>

            <p>
              <strong>Мен, «Қазақстан Республикасының Ұлттық куәландырушы орталығы»</strong> ақпараттық жүйесінің (бұдан әрі – Жүйе)
              пайдаланушысы, Қазақстан Республикасының «Мемлекеттік қызметтер туралы» Заңының 5-бабының 2-тармағының 12)
              тармақшасына және «Дербес деректер және оларды қорғау туралы» Заңының 10-бабына сәйкес,
              «Ұлттық ақпараттық технологиялар» акционерлік қоғамына (БСН 000740000728, бұдан әрі – Оператор)
              <strong> менің дербес деректерімді жинауға, өңдеуге және сақтауға, оларды жалпыға қолжетімді жеке деректер санатына жатқызуға
              келісімімді растаймын.</strong> Келісім «Жүйенің тіркеу куәлігін беру және кері қайтарып алу» мемлекеттік
              қызметін алу және электрондық пошта арқылы хабарламаларды алу мақсатында беріледі.
            </p>

            <h7>1. Жалпыға қолжетімді деректерге жатқызылатын жеке деректердің құрамы:</h7> 
            <br />
            <ul>
              <li>тегі, аты, әкесінің аты;</li>
              <li>жеке сәйкестендіру нөмірі (ЖСН);</li>
              <li>жұмыс орны (ұйымның, құрылымдық бөлімшенің атауы, лауазымы);</li>
              <li>байланыс ақпараты (электрондық пошта мекенжайы, телефон нөмірі, тұратын облысы мен қаласы).</li>
            </ul>

            <p>
              Көрсетілген деректерге қол жеткізу дербес деректер субъектісінің келісімімен жүзеге асырылады.
            </p>

            <p>2. Деректерді алу көздері мен мақсаттары</p>
            <p>
              Менің дербес деректерім Digital ID, мобильді азаматтар базасы, Халыққа қызмет көрсету орталықтарының біріктірілген ақпараттық жүйесі,
              «Жеке тұлғалар» және «Заңды тұлғалар» мемлекеттік деректер базасы ақпараттық жүйелерінен келесі мақсаттарда алынуы мүмкін:
            </p>
            <ul>
              <li>пайдаланушыны сәйкестендіру;</li>
              <li>нысанды автоматтандыру арқылы толтыру;</li>
              <li>жеке деректерді дұрыс енгізу;</li>
              <li>тіркеу куәлігіне ақпарат енгізу;</li>
              <li>деректер өзгерген жағдайда кері қайтарып алу рәсімін автоматтандыру.</li>
            </ul>

            <p>3. Өңдеу шарттары мен тәртібі</p>
            <p>
              Қазақстан Республикасының заңнамасында көзделген жағдайларды қоспағанда, оператор дербес деректерімді автоматтандырылған құралдарды пайдалана отырып өңдейді, олардың құпиялылығын және менің келісімімсіз таратылмауын қамтамасыз етеді.
              Оператор пайдаланушыны электрондық пошта және SMS арқылы хабардар етеді. Дербес деректердің трансшекаралық берілуі жүзеге асырылмайды.
            </p>

            <p>4. Сақтау мерзімі және келісімнің қолданылу тәртібі</p>
            <p>
              Дербес деректерді жинауға, өңдеуге және сақтауға келісім 2025 жылғы 17 маусымдағы №279-НҚ бұйрығымен бекітілген типтік құжаттар тізбесіне сәйкес
              тұрақты негізде жүзеге асырылады. Мұрағаттық сақтау 2023 жылғы 25 тамыздағы №235 бұйрығымен бекітілген
              Ұлттық мұрағат қоры құжаттарын қабылдау, сақтау, есепке алу және пайдалану қағидаларына сәйкес қамтамасыз етіледі.
            </p>

            <p>5. Дербес деректер субъектісінің құқықтары</p>
            <p>
              Дербес деректерді жинауға, өңдеуге және сақтауға келісім Қазақстан Республикасының «Дербес деректер және оларды қорғау туралы» Заңының 9-бабына сәйкес,
              оларды тұрақты сақтау мерзімі белгіленгендіктен, қайтарып алынуға жатпайды.
            </p>

            <p>6. Жауапкершілік</p>
            <p>
              Мен өтінімді өз атымнан және жарамды электрондық пошта мекенжайын көрсете отырып беруге тиіс екенім туралы ескертілдім.
              Сондай-ақ, Қазақстан Республикасының «Электрондық құжат және электрондық цифрлық қолтаңба туралы» заңнамасында көзделген міндеттемелерді орындамау
              Қазақстан Республикасының Әкімшілік құқық бұзушылық туралы кодексінің 640-бабына сәйкес әкімшілік жауаптылыққа әкеп соғатыны туралы хабардармын.
            </p>

            <p>
              Осы келісім пайдаланушы веб-интерфейстегі басқару элементін басу арқылы оның шарттарымен келісімін білдірген сәттен бастап күшіне енеді.
              <br />
              «Мен пайдаланушылық келісімнің шарттарымен таныстым және келісемін».
            </p>
          </div>

          {/* Русская версия */}
          <div className="user-agreement__col2">
            <h3>
              Пользовательское соглашение информационной системы «Национальный удостоверяющий центр Республики Казахстан»
            </h3>

            <p>
              Я, пользователь информационной системы <strong>«Национальный удостоверяющий центр Республики Казахстан»</strong> (далее – Система),
              в соответствии с подпунктом 12) пункта 2 статьи 5 Закона Республики Казахстан «О государственных услугах»
              и статьей 10 Закона Республики Казахстан «О персональных данных и их защите», подтверждаю свое соглашение
              акционерному обществу «Национальные информационные технологии» (БИН 000740000728, далее – Оператор)
              на <strong>сбор, обработку и хранение моих персональных данных, с последующим отнесением их к категории общедоступных персональных данных,</strong>
              в целях получения государственной услуги «Выдача и отзыв регистрационного свидетельства Системы»
              и получения уведомлений на электронную почту.
            </p>

            <p>1. Состав персональных данных, которые будут отнесены к категории общедоступных:</p>
            <ul>
              <li>фамилия, имя, отчество;</li>
              <li>индивидуальный идентификационный номер (ИИН);</li>
              <li>место работы (наименование организации, структурного подразделения, должность);</li>
              <li>контактная информация (адрес электронной почты, номер телефона, область и город проживания).</li>
            </ul>

            <p>Доступ к указанным данным осуществляется с согласия субъекта персональных данных.</p>

            <p>2. Источники и цели получения данных</p>
            <p>
              Я согласен, что мои персональные данные могут быть получены из информационных систем
               Digital ID, база мобильных граждан, Интегрированная информационная система ЦОН,
              государственных баз данных «Физические лица» и «Юридические лица» для следующих целей:
            </p>
            <ul>
              <li>идентификация пользователя;</li>
              <li>автоматизация процесса заполнения формы;</li>
              <li>корректный ввод персональных данных;</li>
              <li>внесение информации в регистрационное свидетельство;</li>
              <li>автоматизация процедуры отзыва при изменении данных.</li>
            </ul>

            <p>3. Условия и порядок обработки</p>
            <p>
              Оператор обрабатывает мои персональные данные с использованием средств автоматизации, обеспечивая их конфиденциальность и недопущение распространения без моего согласия, за исключением случаев, предусмотренных законодательством Республики Казахстан.
              Оператор осуществляет уведомление пользователя по адресу электронной почты и посредством SMS.
              Трансграничная передача персональных данных не осуществляется.
            </p>

            <p>4. Сроки хранения и действия соглашения</p>
            <p>
              Соглашение на сбор, обработку и хранение персональных данных осуществляется на постоянной основе согласно Перечню типовых документов,
              утверждённому приказом от 17 июня 2025 года № 279-НҚ.
              Архивное хранение данных обеспечивается в соответствии с Правилами приёма, хранения, учёта и использования документов Национального архивного фонда,
              утверждёнными приказом от 25 августа 2023 года № 235.
            </p>

            <p>5. Права субъекта персональных данных</p>
            <p>
              Соглашение на сбор, обработку и хранение персональных данных не подлежит отзыву в связи с постоянным сроком их хранения,
              предусмотренным статьёй 9 Закона Республики Казахстан «О персональных данных и их защите».
            </p>

            <p>6. Ответственность</p>
            <p>
              Я предупреждён, что подача заявки должна осуществляться только от своего имени и с указанием действующего адреса электронной почты.
              Я также уведомлён, что невыполнение обязанностей, предусмотренных законодательством Республики Казахстан об электронном документе
              и электронной цифровой подписи, влечёт административную ответственность по статье 640 Кодекса Республики Казахстан об административных правонарушениях.
            </p>

            <p>
              Настоящее соглашение вступает в силу в момент выражения пользователем согласия с его условиями путём нажатия элемента управления веб-интерфейса.
              <br />
              «Я прочитал(а) и согласен(на) с условиями пользовательского соглашения».
            </p>
          </div>
        </div>
      </div>

      <div className="user-agreement-button-area">
        <div>
          <input type="checkbox" id="myCheckbox" onChange={handleCheckboxChange} />
          <label htmlFor="myCheckbox">{t('userAgreement.checkBox')}</label>
        </div>
        <br />
        <input
          className="new-blue-btn"
          type="button"
          id="buttonAcceptAgreement"
          value={t('userAgreement.button')}
          onClick={handleAcceptButtonClick}
          disabled={!isCheckboxChecked}
        />
        <a
          className="user-agreement-main-page"
          href={`${process.env.PUBLIC_URL}/`}
          onClick={handleMainPageLinkClick}
        >
          {t('userAgreement.buttonMainPage')}
        </a>
      </div>
    </div>
  );
};

export default UserAgreement;
